import { render } from "./DirectSalesDataForm.vue?vue&type=template&id=62aff62c&scoped=true&ts=true"
import script from "./DirectSalesDataForm.vue?vue&type=script&lang=ts"
export * from "./DirectSalesDataForm.vue?vue&type=script&lang=ts"

import "./DirectSalesDataForm.vue?vue&type=style&index=0&id=62aff62c&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-62aff62c"]])

export default __exports__